import React, { useEffect, useState } from 'react'
import { Button, Modal, Nav } from 'react-bootstrap'
import filtericon from "../../assets/images/Filter.png";
import DataTable from 'react-data-table-component';
import { RiArrowDownSLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';
import { BsThreeDots } from "react-icons/bs";
import { deleteOrderItem, getCompletedOrdersListing, getOrdersListing, getRejectedOrdersListing } from '../../api/context/orders';
import Loader from '../../components/loader/loader';
import { Box, Paper, Switch, Tooltip } from "@mui/material";
import moment from 'moment';
import ordernew from '../../assets/images/order-new.png';
import deleteIcon from "../../assets/images/delete.png";
import editIcon from "../../assets/images/edit.png";
import viewIcon from "../../assets/svg/view.svg";
import CustomisedModal from '../../components/Modal/CustomisedModal';
import { FaRegSquarePlus } from 'react-icons/fa6';
import { FiPlus, FiEdit2, FiTrash2, FiImage, FiCalendar, FiTag } from 'react-icons/fi';
import CreateBanner from './CreateBanner';
import { getInventoryListingPaginate } from '../../api/context/products';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { createBanner, deleteBannerItem, editBanner, getBannerListing, updateBannerStatus } from '../../api/context/banner';
import toast from 'react-hot-toast'
import imageToBase64 from 'image-to-base64/browser';
import { checkUserPermissions } from '../../helpers/permission';

const queueDatatableCustomStyles = {
    header: {
        style: {
            fontWeight: '700',
            fontSize: '15px',
            color: '#0f172a',
            minHeight: '48px',
            padding: '8px 14px',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            minHeight: '48px',
            paddingLeft: '8px',
            paddingRight: '8px',
        },
    },
    headCells: {
        style: {
            display: 'flex',
            justifyContent: 'center',
            fontWeight: '600',
            fontSize: '9px',
            padding: '10px 14px',
            color: '#475569',
            textTransform: 'uppercase',
            letterSpacing: '0.02em',
            backgroundColor: '#f8fafc',
        },
    },
    cells: {
        style: {
            display: 'flex',
            fontSize: '10px',
            fontWeight: '500',
            color: '#0f172a',
            padding: '10px 14px',
        },
    },
    rows: {
        style: {
            minHeight: '48px',
            borderBottom: '1px solid #eef2f7',
            paddingLeft: '8px',
            paddingRight: '8px',
            transition: 'background 0.15s ease',
            '&:not(:last-of-type)': { borderBottom: '1px solid #eef2f7' },
            '&:hover': { backgroundColor: '#f8fafc !important', cursor: 'pointer' },
        },
    },
    pagination: {
        style: {
            borderTop: '1px solid #eef2f7',
            minHeight: '52px',
            fontSize: '12px',
            color: '#475569',
        },
    },
};

const customStyless = {
    control: (provided) => ({
        ...provided,
        border: " 1px solid #a7a7a7",
        padding: '6px',
    }),
};

const Banner = () => {
    const navigate = useNavigate()
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [banner, setBanner] = useState([]);
    const [products, setProducts] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [update, setUpdate] = useState(false);
    const [initial, setInitial] = useState(false);
    const [search, setSearch] = useState("");
    const [modal, setModal] = useState(false);
    const [deletingId, setDeletingId] = useState("");
    const [selectedBanner, setSelectedBanner] = useState(null);
    const [showimg, setShowImg] = useState(false);
    const [webimg, setWebImg] = useState([]);
    const [showmobimg, setShowMobImg] = useState(false);
    const [mobimg, setMobImg] = useState([]);
    const [activeTab, setActiveTab] = useState('all'); // Added activeTab state

    const handleToggleStatus = async (id) => {
        const previousData = [...banner];
        const currentItem = banner.find(item => item.id === id);
        const newStatus = !currentItem?.isActive;

        setBanner(prevBanner =>
            prevBanner.map(item =>
                item.id === id
                    ? { ...item, isActive: newStatus }
                    : item
            )
        );

        try {
            const response = await new Promise((resolve, reject) => {
                updateBannerStatus(id)(resolve);
            });

            if (response?.data?.statusCode === 200) {
                toast.success("Status updated successfully!");
                if (response.data.banner) {
                    setBanner(prevBanner =>
                        prevBanner.map(item =>
                            item.id === id
                                ? { ...item, ...response.data.banner }
                                : item
                        )
                    );
                }
            } else {
                throw new Error(response?.data?.message || "Failed to update status");
            }
        } catch (error) {
            setBanner(previousData);
            toast.error(error.message);
        }
    };

    const handleShowMobImage = (promoimage) => {
        setShowMobImg(true);
        setMobImg(promoimage)
    }

    const handleCloseImage = () => {
        setShowImg(false);
    }

    const handleCloseMobImage = () => {
        setShowMobImg(false);
    }

    const columns = [
        {
            name: 'Preview',
            center: true,
            minWidth: '85px',
            grow: 0,
            cell: (row) => (
                <div
                    onClick={(e) => { e.stopPropagation(); if (row?.mobileImage) handleShowMobImage(row?.mobileImage); }}
                    style={{
                        width: 64,
                        height: 40,
                        borderRadius: 4,
                        overflow: 'hidden',
                        background: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        cursor: row?.mobileImage ? 'pointer' : 'default',
                        color: '#94a3b8',
                    }}
                >
                    {row?.mobileImage ? (
                        <img
                            src={row.mobileImage}
                            alt={row?.title || ''}
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                        />
                    ) : (
                        <FiImage size={14} />
                    )}
                </div>
            ),
        },
        {
            id: 'title',
            name: 'Title',
            selector: (row) => row?.title,
            cell: (row) => (
                <Tooltip title={row?.title} disableInteractive placement="top">
                    <div style={{
                        fontSize: 10.5,
                        fontWeight: 600,
                        color: '#0f172a',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        minWidth: 0,
                        width: '100%',
                        textAlign: 'center',
                    }}>
                        {row?.title || '—'}
                    </div>
                </Tooltip>
            ),
            grow: 1,
            minWidth: '140px',
            center: true,
        },
        {
            name: 'Status',
            selector: (row) => row.isActive,
            cell: (row, index) => (
                <div onClick={(e) => e.stopPropagation()} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Switch
                        size="small"
                        id={`bnr-switch-${index}`}
                        checked={row.isActive === true}
                        onChange={() => handleToggleStatus(row.id)}
                    />
                </div>
            ),
            sortable: true,
            center: true,
            grow: 0.6,
            minWidth: '90px',
        },
        {
            id: 'createdAt',
            name: 'Created',
            selector: (row) => row?.createdAt,
            cell: (row) => (
                <Tooltip title={moment(row?.createdAt).format('DD/MM/YYYY, hh:mm a')} disableInteractive placement="top">
                    <span style={{ color: '#475569', fontSize: '10px', whiteSpace: 'nowrap' }}>
                        {moment(row?.createdAt).format('DD MMM YY, hh:mm a')}
                    </span>
                </Tooltip>
            ),
            grow: 0.9,
            minWidth: '130px',
            center: true,
        },
        {
            id: 'action',
            name: 'Actions',
            cell: (row) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }} onClick={(e) => e.stopPropagation()}>
                    {checkUserPermissions('edit_banners') && (
                        <Tooltip title="Edit" disableInteractive placement="top">
                            <button
                                type="button"
                                onClick={(e) => { e.stopPropagation(); handleEditClick(row); }}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 24,
                                    height: 24,
                                    borderRadius: 6,
                                    border: '1px solid #cbd5e1',
                                    background: '#f8fafc',
                                    color: '#475569',
                                    cursor: 'pointer',
                                    padding: 0,
                                    transition: 'all 0.15s ease',
                                }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.color = '#0f172a'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.color = '#475569'; }}
                            >
                                <FiEdit2 size={11} />
                            </button>
                        </Tooltip>
                    )}
                    <Tooltip title="Delete" disableInteractive placement="top">
                        <button
                            type="button"
                            onClick={(e) => { e.stopPropagation(); handleConfirm(row?.id); }}
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 24,
                                height: 24,
                                borderRadius: 6,
                                border: '1px solid #fecaca',
                                background: '#fef2f2',
                                color: '#dc2626',
                                cursor: 'pointer',
                                padding: 0,
                                transition: 'all 0.15s ease',
                            }}
                            onMouseEnter={(e) => { e.currentTarget.style.background = '#fee2e2'; }}
                            onMouseLeave={(e) => { e.currentTarget.style.background = '#fef2f2'; }}
                        >
                            <FiTrash2 size={12} />
                        </button>
                    </Tooltip>
                </div>
            ),
            center: true,
            minWidth: '90px',
            grow: 0,
        },
    ]

    // Validation schema and formik setup remain the same...
    const validationSchema = yup.object().shape({
        title: yup
            .string('Enter your firstName')
            .trim()
            .required('Title is required'),
        webImage: selectedBanner?.id ? yup.string().nullable() : yup.string().required('Image is required'),
        mobileImage: selectedBanner?.id ? yup.string().nullable() : yup.string().required('Image is required'),
    });

    const formik = useFormik({
        initialValues: {
            title: '',
            webImage: '',
            webImage_view: '',
            mobileImage: '',
            mobileImage_view: '',
            productId: '',
            selectedProduct: '',
        },
        validationSchema: validationSchema,
        validate: async (values) => {
            const errors = {}
            if (!values.selectedProduct) {
                errors.selectedProduct = "Product is required";
            }
            return errors
        },
        onSubmit: async (values, { resetForm }) => {
            setLoading(true);
            if (values.webImage == '') {
                delete values.webImage;
            }
            delete values.webImage_view;
            if (values.mobileImage == '') {
                delete values.mobileImage;
            }
            delete values.mobileImage_view;
            if (selectedBanner?.id) {
                editBanner(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Banner Updated Successfully")
                        handleClose();
                        setUpdate(!update);
                        setSelectedBanner(null);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            } else {
                createBanner(values)((response) => {
                    if (response && response?.data?.statusCode == 200) {
                        resetForm();
                        toast.success("Banner Created Successfully")
                        handleClose();
                        setUpdate(!update);
                        setLoading(false);
                        setSelectedBanner(null);
                    } else {
                        setLoading(false);
                        toast.error(response?.data?.message);
                    }
                })
            }
        },
    });

    const handleShow = () => setShow(true);

    const handleClose = () => {
        formik.resetForm();
        setShow(false);
        setSelectedBanner(null)
    };

    const fetchBannerData = async () => {
        setLoading(true);
        
        const params = {
            page: page, 
            limit: limit, 
            search
        };

        // Add status filter based on activeTab
        if (activeTab === "active") {
            params.isActive = true;
        } else if (activeTab === "inactive") {
            params.isActive = false;
        }

        getBannerListing(params)((response) => {
            if (response?.statusCode === 200) {
                setBanner(response?.data?.banners || []);
                setTotalRows(response?.data?.pagination?.totalItems || 0);
                setLoading(false);
            } else {
                setBanner([]);
                setTotalRows(0);
                setLoading(false);
            }
        });
    };

    let typingTimer;
    const loadOptionsProducts = inputValue => {
        return new Promise((resolve, reject) => {
            clearTimeout(typingTimer);
            typingTimer = setTimeout(() => {
                if (inputValue.length >= 3) {
                    getInventoryListingPaginate({ page: 1, limit: 10, search: inputValue })(response => {
                        if (response?.statusCode == 200) {
                            resolve(response?.results);
                            setProducts(response?.results)
                        }
                    })
                }
                else {
                    resolve([]);
                }
            }, 300);
        });
    };

    const onProductChange = (selectedOption) => {
        formik.setValues({
            ...formik.values,
            productId: selectedOption ? selectedOption.value : '',
            selectedProduct: selectedOption,
        });
    };

    const handleEditClick = (row) => {
        navigate(`/edit-banner/${row.id}`);
    };

    const handlePerRowsChange = (newPerPage, currentPage) => {
        setLimit(newPerPage);
        setPage(1);
        setUpdate(!update);
    };

    const handlePageChange = (currentPage) => {
        setPage(currentPage);
        setUpdate(!update);
    };

    const handleFilterChange = (filter) => {
        setActiveTab(filter);
        setPage(1); // Reset to first page when changing tabs
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    const handleConfirm = (deletingId) => {
        setModal(!modal);
        setDeletingId(deletingId);
    };

    const handleWebImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }

        if (!validImageTypes.includes(file?.type)) {
            toast.error("Only jpg/jpeg and png files are allowed!");
            e.target.value = null;
            return;
        }

        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            webImage: response,
            webImage_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const handleMobImageChange = async (e) => {
        const file = e?.target?.files[0];
        const maxSizeInBytes = 2 * 1024 * 1024;
        const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

        if (file?.size > maxSizeInBytes) {
            toast.error("File size exceeds 2 MB limit", 'error')
            e.target.value = null;
            return;
        }

        if (!validImageTypes.includes(file?.type)) {
            toast.error("Only jpg/jpeg and png files are allowed!");
            e.target.value = null;
            return;
        }

        const response = await imageToBase64(URL.createObjectURL(file));
        formik.setValues({
            ...formik.values,
            mobileImage: response,
            mobileImage_view: 'data:image/jpeg;base64,' + response,
        });
    }

    const deleteBanner = (id) => {
        setLoading(true);
        deleteBannerItem(id)((response) => {
            if (response?.request?.status == 200) {
                setUpdate(!update);
                setModal(!modal);
                setLoading(false);
                toast.success("Banner deleted successfully")
            } else {
                setLoading(false);
                toast.error("Failed to delete banner");
            }
        });
    };

    useEffect(() => {
        fetchBannerData();
    }, [update, page, limit, activeTab]); // Added activeTab to dependencies

    useEffect(() => {
        let timeout = setTimeout(() => {
            if (initial) {
                setPage(1);
                setUpdate(!update);
            } else {
                setInitial(true);
            }
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [search]);

    return (
        <>
            <div className="banner-page">
                <style>{`
                  /* Base layout — matches Brand/Tracking */
                  .banner-page { background: #f9fafb; min-height: calc(100vh - 70px); }
                  .main-content:has(.banner-page) { background: #f9fafb; }
                  .page-content:has(.banner-page) { background: #f9fafb; }
                  body:has(.banner-page) .container-fluid,
                  body:has(.banner-page) .container {
                    padding-left: 0 !important;
                    padding-right: 0 !important;
                  }
                  body:has(.banner-page) .page-content,
                  body:has(.banner-page) #layout-wrapper.no-topbar .page-content,
                  body:has(.banner-page) #layout-wrapper .page-content {
                    padding-top: 0 !important;
                    padding-bottom: 24px !important;
                    padding-left: 16px !important;
                    padding-right: 16px !important;
                  }
                  .banner-page h3 { font-size: 18px !important; }
                  .banner-page p { font-size: 12px; }
                  .banner-page .row { margin-bottom: 0; }
                  .banner-page .products-and-options .MuiPaper-root {
                    border: 1px solid #e2e8f0 !important;
                    border-radius: 10px !important;
                    overflow: hidden;
                  }

                  /* Sticky header */
                  .banner-page .page-header-sticky {
                    padding: clamp(14px, 1.6vw, 24px) clamp(14px, 1.4vw, 20px) clamp(10px, 1.2vw, 18px) !important;
                    margin: 0 -16px 12px !important;
                    top: 0 !important;
                    background: #f9fafb !important;
                    border-bottom: 1px solid #eef2f7 !important;
                    box-shadow: none !important;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 12px;
                    flex-wrap: wrap;
                  }
                  @media (max-width: 991px) {
                    .banner-page .page-header-sticky { padding: 16px 16px 12px !important; }
                  }
                  @media (max-width: 767.98px) {
                    .banner-page .page-header-sticky {
                      padding: 10px 16px 8px !important;
                      margin: 0 -16px 8px !important;
                      position: static !important;
                      flex-wrap: nowrap !important;
                    }
                  }

                  /* Primary "Add Banner" button */
                  .banner-page .bnr-btn-primary {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 6px 20px !important;
                    border-radius: 6px !important;
                    font-size: 12px !important;
                    font-weight: 600 !important;
                    height: 34px;
                    background: #008695 !important;
                    border: 1px solid #008695 !important;
                    color: #fff !important;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    white-space: nowrap;
                    box-shadow: 0 2px 6px rgba(0,134,149,0.2);
                  }
                  .banner-page .bnr-btn-primary:hover:not(:disabled) {
                    background: #006672 !important;
                    border-color: #006672 !important;
                  }
                  @media (max-width: 480px) {
                    .banner-page .bnr-btn-primary { width: 34px; padding: 0 !important; }
                    .banner-page .bnr-btn-primary .bnr-btn-label { display: none; }
                  }

                  /* Toolbar with segmented tabs */
                  .banner-page .bnr-toolbar {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 10px;
                    margin: 0 0 12px;
                  }
                  .banner-page .bnr-tabs {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    border-bottom: 1px solid #e2e8f0;
                  }
                  .banner-page .bnr-tab-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    padding: 8px 14px;
                    font-size: 12px;
                    font-weight: 600;
                    color: #64748b;
                    background: transparent;
                    border: none;
                    border-bottom: 2px solid transparent;
                    margin-bottom: -1px;
                    cursor: pointer;
                    transition: color 0.15s ease, border-color 0.15s ease;
                  }
                  .banner-page .bnr-tab-btn:hover:not(.is-active) { color: #0f172a; }
                  .banner-page .bnr-tab-btn.is-active {
                    color: #008695;
                    border-bottom-color: #008695;
                  }
                  @media (max-width: 480px) {
                    .banner-page .bnr-tab-btn { padding: 7px 12px; font-size: 11.5px; }
                  }

                  /* Empty state */
                  .banner-page .bnr-empty {
                    width: 100%;
                    min-height: 320px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 32px 20px;
                    text-align: center;
                    color: #64748b;
                    background: linear-gradient(180deg, #fafbfd 0%, #f5f7fa 100%);
                  }
                  .banner-page .bnr-empty-icon { font-size: 40px; margin-bottom: 12px; opacity: 0.7; }
                  .banner-page .bnr-empty-title { font-size: 14px; font-weight: 700; color: #0f172a; margin: 0 0 4px; }
                  .banner-page .bnr-empty-sub { font-size: 12px; color: #94a3b8; font-weight: 500; margin: 0; }

                  /* Mobile card list (hidden on desktop) */
                  .banner-page .bnr-mobile-list { display: none; }
                  .banner-page .bnr-mobile-loading { min-height: 40vh; display: flex; align-items: center; justify-content: center; }
                  .banner-page .bnr-mobile-pagination { display: none; }

                  @media (max-width: 767.98px) {
                    .banner-page .bnr-desktop-table { display: none !important; }
                    .banner-page .bnr-mobile-list {
                      display: block;
                      padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px));
                    }

                    /* Fixed bottom pagination */
                    .banner-page .bnr-mobile-pagination {
                      display: flex !important;
                      position: fixed;
                      left: 0; right: 0; bottom: 0;
                      padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px));
                      background: #fff;
                      border-top: 1px solid #e2e8f0;
                      box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
                      z-index: 1049;
                      align-items: center;
                      justify-content: space-between;
                      gap: 10px;
                    }
                    .banner-page .bmp-btn {
                      width: 40px; height: 36px;
                      border-radius: 6px;
                      border: 1px solid #e2e8f0;
                      background: #fff;
                      color: #0f172a;
                      font-size: 16px;
                      font-weight: 700;
                      cursor: pointer;
                      display: inline-flex; align-items: center; justify-content: center;
                      transition: all 0.15s ease;
                    }
                    .banner-page .bmp-btn:hover:not(:disabled) {
                      border-color: #008695;
                      color: #008695;
                      background: rgba(0,134,149,0.06);
                    }
                    .banner-page .bmp-btn:disabled { opacity: 0.35; cursor: not-allowed; }
                    .banner-page .bmp-info {
                      font-size: 11px;
                      color: #475569;
                      display: inline-flex;
                      align-items: baseline;
                      gap: 4px;
                      flex: 1;
                      justify-content: center;
                      text-align: center;
                    }
                    .banner-page .bmp-info strong { color: #008695; font-weight: 700; }
                    .banner-page .bmp-total { color: #94a3b8; font-size: 10px; }
                  }

                  /* Card */
                  .banner-page .bnr-card {
                    display: flex;
                    align-items: stretch;
                    gap: 12px;
                    background: #fff;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    padding: 10px;
                    margin-bottom: 8px;
                    box-shadow: 0 1px 2px rgba(15,23,42,0.03);
                    cursor: pointer;
                    transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
                  }
                  .banner-page .bnr-card:active { transform: scale(0.995); }
                  .banner-page .bnr-card:hover {
                    border-color: #cbd5e1;
                    box-shadow: 0 2px 6px rgba(15,23,42,0.06);
                  }
                  .banner-page .bnr-card-image {
                    width: 96px;
                    min-width: 96px;
                    height: 96px;
                    border-radius: 8px;
                    overflow: hidden;
                    background: #f1f5f9;
                    border: 1px solid #e2e8f0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #94a3b8;
                    flex-shrink: 0;
                  }
                  .banner-page .bnr-card-image img {
                    width: 100%; height: 100%; object-fit: cover; display: block;
                  }
                  .banner-page .bnr-card-content {
                    flex: 1;
                    min-width: 0;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    gap: 6px;
                    padding: 2px 0;
                  }
                  .banner-page .bnr-card-title {
                    font-size: 13px;
                    font-weight: 600;
                    color: #0f172a;
                    letter-spacing: -0.01em;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    line-height: 1.3;
                  }
                  .banner-page .bnr-card-date {
                    font-size: 10.5px;
                    color: #94a3b8;
                    font-weight: 500;
                  }
                  .banner-page .bnr-card-footer {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    gap: 8px;
                  }
                  .banner-page .bnr-card-action-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    width: 30px;
                    height: 30px;
                    border-radius: 6px;
                    background: #f8fafc;
                    border: 1px solid #cbd5e1;
                    color: #475569;
                    cursor: pointer;
                    padding: 0;
                    transition: all 0.15s ease;
                  }
                  .banner-page .bnr-card-action-btn.is-danger {
                    background: #fef2f2;
                    border-color: #fecaca;
                    color: #dc2626;
                  }

                  /* Delete modal */
                  .bnr-delete-modal { max-width: 380px; }
                  .bnr-delete-modal-content {
                    border: none !important;
                    border-radius: 14px !important;
                    box-shadow: 0 20px 50px rgba(15,23,42,0.18) !important;
                    overflow: hidden !important;
                  }
                  @media (max-width: 480px) {
                    .bnr-delete-modal { max-width: none !important; width: calc(100vw - 24px) !important; margin: 0 auto !important; }
                  }
                `}</style>

                <div className="page-header-sticky">
                    <h3 style={{ fontSize: '18px', fontWeight: 700, color: '#111827', margin: 0, letterSpacing: '-0.01em' }}>Banners</h3>
                    <button
                        type="button"
                        className="bnr-btn-primary"
                        onClick={() => navigate('/create-banner')}
                        title="Add Banner"
                    >
                        <FiPlus strokeWidth={2.5} />
                        <span className="bnr-btn-label">Add Banner</span>
                    </button>
                </div>

                {/* Toolbar — segmented tabs */}
                <div className="bnr-toolbar">
                    <div className="bnr-tabs" role="tablist">
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === 'all'}
                            className={`bnr-tab-btn${activeTab === 'all' ? ' is-active' : ''}`}
                            onClick={() => { setActiveTab('all'); handleFilterChange('all'); }}
                        >
                            All
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === 'active'}
                            className={`bnr-tab-btn${activeTab === 'active' ? ' is-active' : ''}`}
                            onClick={() => { setActiveTab('active'); handleFilterChange('active'); }}
                        >
                            Active
                        </button>
                        <button
                            type="button"
                            role="tab"
                            aria-selected={activeTab === 'inactive'}
                            className={`bnr-tab-btn${activeTab === 'inactive' ? ' is-active' : ''}`}
                            onClick={() => { setActiveTab('inactive'); handleFilterChange('inactive'); }}
                        >
                            Inactive
                        </button>
                    </div>
                </div>

                <div className='col-12 bnr-desktop-table'>
                    <Box className="products-and-options" sx={{ mt: 1 }}>
                        <Paper square className='shadow-none border-0'>
                            <div>
                                <DataTable
                                    onRowClicked={(row) => handleEditClick(row)}
                                    columns={columns}
                                    data={banner}
                                    progressPending={loading}
                                    progressComponent={<div style={{ height: '60vh' }}><Loader /></div>}
                                    pagination
                                    paginationServer
                                    pointerOnHover
                                    highlightOnHover
                                    paginationTotalRows={totalRows}
                                    paginationRowsPerPageOptions={[10, 50, 100, 150]}
                                    paginationPerPage={limit}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onChangePage={handlePageChange}
                                    paginationDefaultPage={page}
                                    customStyles={queueDatatableCustomStyles}
                                    noDataComponent={
                                        <div className="bnr-empty">
                                            <div className="bnr-empty-icon" aria-hidden="true">🖼️</div>
                                            <div className="bnr-empty-title">No banners found</div>
                                            <div className="bnr-empty-sub">Try switching tabs or add a new banner.</div>
                                        </div>
                                    }
                                />
                            </div>
                        </Paper>
                    </Box>
                </div>

                {/* Mobile card list */}
                <div className="bnr-mobile-list">
                    {loading ? (
                        <div className="bnr-mobile-loading"><Loader /></div>
                    ) : banner && banner.length > 0 ? (
                        banner.map((row, index) => (
                            <div
                                key={row.id ?? index}
                                className="bnr-card"
                                onClick={() => handleEditClick(row)}
                            >
                                <div
                                    className="bnr-card-image"
                                    onClick={(e) => { e.stopPropagation(); if (row?.mobileImage) handleShowMobImage(row?.mobileImage); }}
                                    style={{ cursor: row?.mobileImage ? 'pointer' : 'default' }}
                                >
                                    {row?.mobileImage ? (
                                        <img
                                            src={row.mobileImage}
                                            alt={row?.title || ''}
                                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                                        />
                                    ) : (
                                        <FiImage size={24} />
                                    )}
                                </div>
                                <div className="bnr-card-content">
                                    <div>
                                        <div className="bnr-card-title">{row?.title || '—'}</div>
                                        <div className="bnr-card-date">
                                            {moment(row?.createdAt).format('DD MMM YY, hh:mm a')}
                                        </div>
                                    </div>
                                    <div className="bnr-card-footer">
                                        <div onClick={(e) => e.stopPropagation()} style={{ display: 'flex', alignItems: 'center' }}>
                                            <Switch
                                                size="small"
                                                id={`bnr-m-switch-${index}`}
                                                checked={row.isActive === true}
                                                onChange={() => handleToggleStatus(row.id)}
                                            />
                                        </div>
                                        <div style={{ display: 'inline-flex', gap: 6 }}>
                                            {checkUserPermissions('edit_banners') && (
                                                <button
                                                    type="button"
                                                    aria-label="Edit banner"
                                                    className="bnr-card-action-btn"
                                                    onClick={(e) => { e.stopPropagation(); handleEditClick(row); }}
                                                >
                                                    <FiEdit2 size={13} />
                                                </button>
                                            )}
                                            <button
                                                type="button"
                                                aria-label="Delete banner"
                                                className="bnr-card-action-btn is-danger"
                                                onClick={(e) => { e.stopPropagation(); handleConfirm(row?.id); }}
                                            >
                                                <FiTrash2 size={14} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="bnr-empty">
                            <div className="bnr-empty-icon" aria-hidden="true">🖼️</div>
                            <div className="bnr-empty-title">No banners found</div>
                            <div className="bnr-empty-sub">Try switching tabs or add a new banner.</div>
                        </div>
                    )}
                </div>

                {/* Mobile-only fixed pagination */}
                {(() => {
                    const totalPages = Math.max(1, Math.ceil((totalRows || 0) / (limit || 1)));
                    const canPrev = page > 1;
                    const canNext = page < totalPages;
                    return (
                        <div className="bnr-mobile-pagination">
                            <button
                                type="button"
                                className="bmp-btn"
                                onClick={() => canPrev && handlePageChange(page - 1)}
                                disabled={!canPrev}
                                aria-label="Previous page"
                            >
                                ←
                            </button>
                            <span className="bmp-info">
                                Page <strong>{page}</strong> of <strong>{totalPages}</strong>
                                <span className="bmp-total">· {totalRows || 0} banners</span>
                            </span>
                            <button
                                type="button"
                                className="bmp-btn"
                                onClick={() => canNext && handlePageChange(page + 1)}
                                disabled={!canNext}
                                aria-label="Next page"
                            >
                                →
                            </button>
                        </div>
                    );
                })()}
            </div>

            {/* Rest of the modals and components remain the same */}
            <CreateBanner
                show={show}
                handleClose={handleClose}
                handleShow={handleShow}
                loading={loading}
                loadOptionsProducts={loadOptionsProducts}
                products={products}
                onProductChange={onProductChange}
                customStyles={customStyless}
                formik={formik}
                selectedBanner={selectedBanner}
                handleWebImageChange={handleWebImageChange}
                handleMobImageChange={handleMobImageChange}
                // handleSubImageChange={handleSubImageChange}
            />
            <Modal
                show={modal}
                onHide={() => !loading && setModal(false)}
                centered
                backdrop={loading ? 'static' : true}
                keyboard={!loading}
                dialogClassName="bnr-delete-modal"
                contentClassName="bnr-delete-modal-content"
            >
                <Modal.Body style={{ padding: '22px 22px 18px', textAlign: 'center' }}>
                    <div
                        style={{
                            width: 52,
                            height: 52,
                            borderRadius: '50%',
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 12,
                        }}
                    >
                        <FiTrash2 size={22} />
                    </div>
                    <h5 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: '0 0 6px', letterSpacing: '-0.01em' }}>
                        Delete banner?
                    </h5>
                    <p style={{ fontSize: 12.5, color: '#64748b', margin: 0, lineHeight: 1.5 }}>
                        This action cannot be undone. The selected banner will be permanently removed.
                    </p>
                </Modal.Body>
                <Modal.Footer
                    style={{
                        padding: '12px 18px',
                        borderTop: '1px solid #eef2f7',
                        display: 'flex',
                        gap: 8,
                        justifyContent: 'stretch',
                    }}
                >
                    <button
                        type="button"
                        onClick={() => setModal(false)}
                        disabled={loading}
                        style={{
                            flex: 1,
                            height: 38,
                            borderRadius: 6,
                            border: '1px solid #e2e8f0',
                            background: '#fff',
                            color: '#0f172a',
                            fontSize: 12.5,
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.6 : 1,
                            transition: 'all 0.15s ease',
                        }}
                    >
                        No
                    </button>
                    <button
                        type="button"
                        onClick={() => deleteBanner(deletingId)}
                        disabled={loading}
                        style={{
                            flex: 1,
                            height: 38,
                            borderRadius: 6,
                            border: '1px solid #dc2626',
                            background: '#dc2626',
                            color: '#fff',
                            fontSize: 12.5,
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.85 : 1,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 6,
                            boxShadow: '0 3px 8px rgba(220,38,38,0.22)',
                            transition: 'all 0.15s ease',
                        }}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                                Deleting...
                            </>
                        ) : (
                            <>
                                <FiTrash2 size={13} />
                                Yes, Delete
                            </>
                        )}
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal
                show={showimg}
                onHide={handleCloseImage}
                centered
                className='modal_create'
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="promo_modal_img">
                    <img src={webimg} alt='' className="img-fluid" />
                </div>
            </Modal>

            <Modal
                show={showmobimg}
                onHide={handleCloseMobImage}
                centered
                className='modal_create'
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <div className="promo_modal_img">
                    <img src={mobimg} alt='' className="img-fluid" />
                </div>
            </Modal>
        </>
    )
}

export default Banner